/*
 * @Description:
 * @Author: zhanglu
 * @Date: 2020-08-19 18:48:23
 * @LastEditors: zhanglu
 * @LastEditTime: 2020-10-28 14:49:35
 */
/**********************消息中心接口***********************/
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  // COMMON_MESSAGE_PUSH_CENTER = "",
  E6_MS_TMS_REPORT_WEB = ""
} = e6ModuleBaseDataApi;
// // 获取菜单树
// export function getMessageCenterMenu(data) {
//   return http({
//     url: `${host}${COMMON_MESSAGE_PUSH_CENTER}/message/push/findMenuTree`,
//     method: "post",
//     data
//   });
// }
// 获取消息列表
// export function getMessageCenterList(type, data) {
//   return http({
//     url: `${host}${COMMON_MESSAGE_PUSH_CENTER}/message/push/findByPage/${type}`,
//     method: "post",
//     data
//   });
// }

// // 标记一条未读消息为已读
// export function markMessageRead(receiverType, receiver) {
//   return http({
//     url: `${host}${COMMON_MESSAGE_PUSH_CENTER}/message/push/markMessageRead/${receiverType}/${receiver}`,
//     method: "get"
//   });
// }

// 获取消息中心顶部tabs数据
export function getTabsType(params) {
  return http({
    url: `${host}${E6_MS_TMS_REPORT_WEB}/webMessage/getTypeTree`,
    method: "get",
    params
  });
}
export function getMessageList(data) {
  return http({
    url: `${host}${E6_MS_TMS_REPORT_WEB}/webMessage/findByPage`,
    method: "post",
    data
  });
}
